<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 1200px;">
      <header class="modal-card-head">
        <p class="modal-card-title">Payment History #{{ payment_id }}</p>
      </header>
      <section class="modal-card-body">
        <div class="content" v-if="paymentHistory">
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <th>Booking-Service</th>
                <th>History</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="history in paymentHistory">
                <template v-if="history.service">
                  <td><a @click="url(history.service.id)">{{history.service.api_booking_id + '/' + history.service.api_service_id}}</a></td>
                </template>
                <template v-else>
                  <td></td>
                </template>
                <td v-html="history.history"></td>
                <td>{{ parseDate(history.created_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(false)">Cancel</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import message from '../../../../utils/message'
  // import Payment from '../finances/payment'
  export default {
    props: {
      context: {
        type: Object
      },
      payment_id: {
        type: Number,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        paymentHistory: null
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      url (service) {
        window.open('#/services/service/' + service)
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/V2/payment/' + this.payment_id + '/history').then((response) => {
          this.paymentHistory = response.body
          if (response.body === '') {
            this.close(false)
          } else {
            document.body.appendChild(this.$el)
          }
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      close (closeOnly, result) {
        if ((!closeOnly) && (typeof this.context[this.callback] === 'function')) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      parseDate (content) {
        return this.$moment(content).format('YYYY-MM-DD')
      }
    }
  }
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// PaymentHistory.vue?d36eabf4